import { NotificationIcon, useSession } from '@zhiyue/core';
import React from 'react';
import { hasOAuth2Session } from '@/services/oauth2';

const SafeNotificationIcon: React.FC = () => {
  const { currentUser, loading } = useSession();
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    if (loading) {
      setReady(false);
      return;
    }

    setReady(Boolean(currentUser) && hasOAuth2Session());
  }, [currentUser, loading]);

  if (!ready) {
    return null;
  }

  return <NotificationIcon />;
};

export default SafeNotificationIcon;
